var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 .089 3.684 41.41 20.222 46l16.551-4.588L40.464.09H0Zm32.471 13.513H13.077l.463 5.19h18.471l-1.39 15.564-10.39 2.878-.006.002-10.383-2.88-.725-8.14h5.087l.377 4.222 5.645 1.526.007-.003 5.65-1.526.589-6.572H8.907L7.538 8.536H32.924l-.453 5.066Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.4ae51cad47835829d99051ea0e7e4095.svg";
export { ForwardRef as ReactComponent };